// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3DCAUMUMaawOZxKkxIPElm","letter":"_2JW7PDgvoPb1F6xOfHtlUb","editMessageIcon":"rssbiFRdn5l15RPt_91kS","editMessageText":"yaLVPgfo6lhQkOi8VFYjb"};